/* GENERATED by scripts/gen-data.mjs — cross-chapter retrieval items merged into the checks (from s5.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { CarryItem } from '../types';

export const CARRY: Record<string, CarryItem> = {
  "memory.b4": {
    "from": "03",
    "bin": 0,
    "tKey": "path:memory.b4.carry.t",
    "whyKey": "path:memory.b4.carry.why"
  },
  "grounding.b4": {
    "from": "02",
    "bin": 0,
    "tKey": "path:grounding.b4.carry.t",
    "whyKey": "path:grounding.b4.carry.why"
  },
  "service-split.b4": {
    "from": "05",
    "bin": 2,
    "tKey": "path:service-split.b4.carry.t",
    "whyKey": "path:service-split.b4.carry.why"
  },
  "tooling.b4": {
    "from": "01",
    "bin": 2,
    "tKey": "path:tooling.b4.carry.t",
    "whyKey": "path:tooling.b4.carry.why"
  },
  "guardrails.b4": {
    "from": "06",
    "bin": 0,
    "tKey": "path:guardrails.b4.carry.t",
    "whyKey": "path:guardrails.b4.carry.why"
  },
  "evaluate.b4": {
    "from": "09",
    "bin": 0,
    "tKey": "path:evaluate.b4.carry.t",
    "whyKey": "path:evaluate.b4.carry.why"
  },
  "frontend-composition.b4": {
    "from": "02",
    "tKey": "path:frontend-composition.b4.carry.t",
    "fbKey": "path:frontend-composition.b4.carry.fb"
  },
  "production.b4": {
    "from": "10",
    "tKey": "path:production.b4.carry.t",
    "fbKey": "path:production.b4.carry.fb"
  },
  "deploy.b4": {
    "from": "11",
    "bin": 1,
    "tKey": "path:deploy.b4.carry.t",
    "whyKey": "path:deploy.b4.carry.why"
  },
  "monitor.b4": {
    "from": "12",
    "tKey": "path:monitor.b4.carry.t",
    "fbKey": "path:monitor.b4.carry.fb"
  }
};
